import './style/App.css'
import React, { Suspense } from 'react'
import { renderRoutes } from 'react-router-config'
import { createBrowserHistory } from 'history'
import * as Sentry from '@sentry/react'
import routes from './routes'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'
import { useSetRecoilState } from 'recoil'

import { adsState } from 'global/forms'
import { BaseHeader } from 'components/base-header'
import { BaseFooter } from 'components/base-footer'
export const history = createBrowserHistory()

const useSentry = process.env.REACT_APP_USE_SENTRY
const sentrySetting = {
  dsn: process.env.REACT_APP_SENTRY_DNS,
  release: process.env.REACT_APP_VERSION,
  environment: process.env.REACT_APP_ENVIRONMENT
}

if (useSentry == 'true') Sentry.init(sentrySetting)

// console.log('Using sentry: ', useSentry, sentrySetting)

const App = () => {
  const { search } = useLocation()
  const setAdsState = useSetRecoilState(adsState)

  const urlParams = new URLSearchParams(search)
  const params = Object.fromEntries(urlParams) // {abc: "foo", def: "[asf]", xyz: "5"}

  if (!_.isEmpty(params)) {
    setAdsState(params)
  }
  return (
    <>
      <BaseHeader />
      <main className="App App-header">
        <Sentry.ErrorBoundary fallback={'An error has occurred'}>{renderRoutes(routes)}</Sentry.ErrorBoundary>
      </main>
      <BaseFooter />
    </>
  )
}

export default App
